// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"453":"efe3ecc9","677":"85de4b24"}[chunkId] + ".chunk.js");